// Hero continuum band illustration — the visual signature.
// Five lit nodes along a horizontal gradient band.
export default function HeroContinuum({ className = "" }) {
  const nodes = [
    { name: "Housing", x: 60 },
    { name: "Homelessness", x: 200 },
    { name: "Mental Health", x: 360 },
    { name: "Addiction", x: 520 },
    { name: "Community", x: 680 },
  ];
  return (
    <div className={`relative w-full ${className}`} data-testid="hero-continuum">
      <svg viewBox="0 0 740 240" className="w-full">
        <defs>
          <linearGradient id="continuum-grad" x1="0" x2="1">
            <stop offset="0%" stopColor="#0A1224" />
            <stop offset="25%" stopColor="#3B4C68" />
            <stop offset="50%" stopColor="#8898AA" />
            <stop offset="75%" stopColor="#D9A05B" />
            <stop offset="100%" stopColor="#FF8A00" />
          </linearGradient>
        </defs>

        {/* Indicator panel rectangles above each node */}
        {nodes.map((n, i) => (
          <g key={n.name}>
            <rect
              x={n.x - 50}
              y={20}
              width={100}
              height={70}
              fill="rgba(255,255,255,0.04)"
              stroke="rgba(255,255,255,0.15)"
              strokeWidth="1"
            />
            {/* Mini bar chart */}
            {[18, 32, 26, 44, 30, 38].map((h, j) => (
              <rect
                key={j}
                x={n.x - 44 + j * 14}
                y={84 - h}
                width={10}
                height={h}
                fill={i === 4 ? "#FF8A00" : "rgba(255,255,255,0.55)"}
                opacity={0.6 + (j % 3) * 0.1}
              />
            ))}
            <text
              x={n.x}
              y={196}
              textAnchor="middle"
              fill="rgba(255,255,255,0.7)"
              fontSize="11"
              fontWeight="700"
              letterSpacing="2"
            >
              {n.name.toUpperCase()}
            </text>
          </g>
        ))}

        {/* The gradient band */}
        <rect x="20" y="120" width="700" height="6" fill="url(#continuum-grad)" />

        {/* Nodes on the band */}
        {nodes.map((n, i) => (
          <g key={`node-${i}`}>
            <circle cx={n.x} cy={123} r="10" fill="#0A1224" stroke="rgba(255,255,255,0.2)" />
            <circle cx={n.x} cy={123} r="5" fill={i === 4 ? "#FF8A00" : "#FFFFFF"} />
            <line x1={n.x} y1={90} x2={n.x} y2={113} stroke="rgba(255,255,255,0.2)" strokeWidth="1" strokeDasharray="2 3" />
          </g>
        ))}
      </svg>
    </div>
  );
}
